export enum StockLevel {
  IN_STOCK = 'IN_STOCK',
  LIMITED_STOCK = 'LIMITED_STOCK',
  OUT_OF_STOCK = 'OUT_OF_STOCK'
}

export enum ShippingMethodEnum {
  SAME_DAY = 'SAME_DAY',
  NEXT_DAY = 'NEXT_DAY',
  DATE_RANGE = 'DATE_RANGE',
  SCHEDULED = 'SCHEDULED',
  SCHEDULED_DEFERRED = 'SCHEDULED_DEFERRED'
}

export enum NodeType {
  WAREHOUSE = 'WAREHOUSE',
  SELLER = 'SELLER',
  PROVIDER = 'PROVIDER',
  STORE = 'STORE',
  THREE_PL = '3PL'
}
export enum LogisticModel {
  OWNED = 'OWNED',
  DROP_SHIPPING = 'DROP_SHIPPING',
  FULFILLMENT_BY = 'FULFILLMENT_BY',
  FLEX = 'FLEX'
}

export enum ShippingTypeEnum {
  DELIVERY = 'DELIVERY',
  COLLECT = 'COLLECT'
}
export enum ShippingSubTypeEnum {
  IN_STORE = 'IN_STORE',
  LOCAL = 'LOCAL',
  COPEC = 'COPEC'
}
